export const duplicateFavoriteDisplayNameTemplate = "AzGVnd";
export const duplicateFavoriteTooltipTemplate = "gyJ$3d";
export const duplicateFavoriteParentFolderTemplate = "JXNPve";
export default {duplicateFavoriteDisplayNameTemplate,duplicateFavoriteTooltipTemplate,duplicateFavoriteParentFolderTemplate};